import { render } from "./Almacenes.vue?vue&type=template&id=955377fa"
import script from "./Almacenes.vue?vue&type=script&lang=js"
export * from "./Almacenes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__